import PropTypes from 'prop-types';
import React from 'react';

import ContentfulImage from '../Common/ContentfulImage';
import PageSection from '../Common/PageSection';
import RichTextConverter from '../Common/RichText/RichTextConverter';
import * as styles from './FullCenteredHeading.module.css';

const FullCenteredHeading = ({ superText, heading, copy, image, backgroundImage }) => {
  return (
    <PageSection
      isTopSection
      wide
      className={styles.section}
      style={{ '--backgroundImage': `url('${backgroundImage?.file?.url}')` }}
    >
      <div className={styles.wrap}>
        <div className={styles.headingCopy}>
          <span className={styles.superText}>{superText}</span>
          <h1>{heading}</h1>
          <RichTextConverter copy={copy} className={styles.copy} />
        </div>
        <ContentfulImage className={styles.image} imageFragment={image} />
      </div>
    </PageSection>
  );
};

FullCenteredHeading.propTypes = {
  superText: PropTypes.string,
  heading: PropTypes.string.isRequired,
  copy: PropTypes.object,
  image: PropTypes.object,
  backgroundImage: PropTypes.object,
};

export default FullCenteredHeading;
